import axios from 'axios';
import { API_BASE_URL } from '../config';

export function resolveLaravelRoot(apiBaseUrl) {
  const normalized = String(apiBaseUrl || '').trim().replace(/\/+$/, '');
  return normalized.replace(/\/api$/i, '');
}

const profileUploadApi = axios.create({
  baseURL: resolveLaravelRoot(API_BASE_URL),
  timeout: 20000,
});

function profileImageFile(dataUrl) {
  const matched = String(dataUrl || '').match(/^data:(image\/(?:jpeg|png|gif|webp));base64,([A-Za-z0-9+/]+={0,2})$/);
  if (!matched) throw new Error('头像图片数据无效');
  const binary = atob(matched[2]);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
  const extension = matched[1] === 'image/jpeg' ? 'jpg' : matched[1].split('/')[1];
  return new File([bytes], `avatar.${extension}`, { type: matched[1] });
}

export async function uploadProfileImage(dataUrl) {
  const data = new FormData();
  data.append('file', profileImageFile(dataUrl));
  const token = localStorage.getItem('token');
  const response = await profileUploadApi.post('/api/media/upload', data, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  const payload = response.data;
  const url = payload?.data?.url;
  if (Number(payload?.code) !== 200 || typeof url !== 'string' || !url.trim()) {
    throw new Error(payload?.message || '头像上传失败');
  }
  return url.trim();
}

export default profileUploadApi;
